// bankReceipt page strings. Keys are read as $t('bankReceipt.<key>').
export default {
  en: {
    pageTitle: 'Bank Receipts - FitFoodCS',
    title: 'Bank Receipts',
    subtitle: 'Posts of the Mattermost channel bankreceipt, with what Claude read from each picture.',
    from: 'From',
    to: 'To',
    search: 'Phone, name, amount, text…',
    filterGroup: { picture: 'Posts', claude: 'Claude', mapped: 'Mapped' },
    filterConflict: 'Cannot go with "{other}"',
    filterApply: 'Apply',
    receiverFilter: { label: 'Receiver bank', all: 'All receiver banks', other: 'Other banks', none: 'No receiver bank' },
    sortHint: 'Click to sort: newest first, click again for oldest first',
    filterClear: 'Clear',
    chooseAll: 'Choose all on this page (the ones that may be chosen)',
    show: {
      all: 'All posts',
      pictures: 'With a picture',
      unread: 'Not read by Claude',
      chosen: 'Chosen, waiting for Claude',
      read: 'Read by Claude',
      failed: "Claude couldn't read",
      mapped: 'Mapped',
      human_mapped: 'Seen by staff',
      auto_closed: 'Auto closed',
      unmapped: 'Not mapped',
    },
    mapped: {
      seen: 'Đã thấy: reply in the Mattermost thread that you saw this transfer',
      message: '{user} đã thấy giao dịch này',
      confirm: 'Post "{message}" in this picture\'s Mattermost thread?',
      human: 'Đã thấy: {user}',
      auto: 'Auto closed: {why}',
    },
    sync: 'Sync now',
    syncing: 'Syncing…',
    read: 'Read now',
    download: 'Excel',
    syncedAt: 'Synced {time}',
    neverSynced: 'Not synced yet',
    history: 'Copying the channel history: {done} of about {total} posts',
    syncFailed: 'Sync failed: {error}',
    reader: {
      waiting: '{n} chosen pictures waiting for Claude',
      failed: "{n} couldn't be read",
      running: "Reading on {user}'s computer since {time}: {read} read, {failed} failed",
      lastRun: 'Last run by {user}, {time}: {read} read, {failed} failed',
      nothing: 'Nothing waiting',
    },
    help: {
      title: 'How Claude reads the pictures',
      step1: 'Once per computer: install Claude Code and sign in, then click "Install reader" and run the file it downloads.',
      step2: 'Tick "Chosen" on the pictures for Claude to read (the box in the title chooses the whole page). Mapped pictures and ones already read cannot be chosen.',
      step3: 'Click "Read now" and let the browser open the reader.',
      step4: 'A window on this computer shows Claude reading the chosen pictures one by one; leave it open, it closes itself when done.',
      step5: 'The rows fill in by themselves as each picture is read. "Claude couldn\'t read" ones can be chosen again.',
      note: 'Several computers can read at once: each takes different pictures. "Remove reader" takes it off a computer.',
    },
    install: {
      button: 'Install reader',
      hint: 'Once per computer: lets "Read now" start Claude Code here. Needs Claude Code installed and signed in.',
      opened: 'Claude Code starts in a window on this computer (allow the browser to open it). If nothing opened, this computer needs the reader once:',
      remove: 'Remove reader',
      removeHint: 'Takes the reader off this computer: "Read now" no longer opens Claude Code here.',
    },
    rows: '{from}–{to} of {shown} posts',
    pager: { label: 'Pages', first: 'First page', prev: 'Previous page', next: 'Next page', last: 'Last page', size: 'Per page' },
    narrow: 'Only the newest {max} are shown: narrow the dates or search.',
    empty: 'No posts for these filters.',
    col: {
      posted: 'Posted',
      author: 'By',
      phoneMm: 'Phone (MST)',
      message: 'Message',
      links: 'Links',
      mapped: 'Mapped',
      chosen: 'Chosen',
      chosenFor: 'for LLM',
      llm: 'Claude',
      method: 'Method',
      amount: 'Amount',
      sender: 'Sender',
      receiver: 'Receiver',
      txnAt: 'Trans Time',
      success: 'OK',
      phonePic: 'Phone in picture',
      description: 'Description',
    },
    picture: 'Picture',
    customerLink: "Open this customer's Order Hist",
    post: 'Post',
    reply: 'reply',
    llm: {
      read: 'Read',
      waiting: 'Chosen',
      failed: 'Failed',
      none: '—',
    },
    panel: {
      title: 'Picture',
      prev: 'Previous picture (←)',
      next: 'Next picture (→)',
      close: 'Close (Esc)',
      move: 'Drag to move the panel, a corner to resize it; double-click to put it back',
      resize: 'Drag to resize',
      reset: 'Put the panel back on the right at its normal size',
      full: 'Full size',
      post: 'Open in Mattermost',
      failed: "Couldn't load the picture from Mattermost",
    },
    yes: 'Yes',
    no: 'No',
  },
  vi: {
    pageTitle: 'Bank Receipts - FitFoodCS',
    title: 'Bank Receipts',
    subtitle: 'Các bài trong kênh Mattermost bankreceipt, kèm thông tin Claude đọc từ ảnh.',
    from: 'Từ',
    to: 'Đến',
    search: 'SĐT, tên, số tiền, nội dung…',
    filterGroup: { picture: 'Bài', claude: 'Claude', mapped: 'Map' },
    filterConflict: 'Không chọn cùng "{other}" được',
    filterApply: 'Áp dụng',
    receiverFilter: { label: 'Ngân hàng nhận', all: 'Tất cả ngân hàng nhận', other: 'Ngân hàng khác', none: 'Chưa có ngân hàng nhận' },
    sortHint: 'Bấm để sắp xếp: mới nhất trước, bấm lần nữa để cũ nhất trước',
    filterClear: 'Bỏ lọc',
    chooseAll: 'Chọn tất cả trên trang này (những ảnh chọn được)',
    show: {
      all: 'Tất cả bài',
      pictures: 'Có ảnh',
      unread: 'Claude chưa đọc',
      chosen: 'Đã chọn, chờ Claude đọc',
      read: 'Claude đã đọc',
      failed: 'Claude không đọc được',
      mapped: 'Đã map',
      human_mapped: 'Nhân viên đã thấy',
      auto_closed: 'Tự đóng',
      unmapped: 'Chưa map',
    },
    mapped: {
      seen: 'Đã thấy: trả lời trong thread Mattermost rằng bạn đã thấy giao dịch này',
      message: '{user} đã thấy giao dịch này',
      confirm: 'Đăng "{message}" vào thread Mattermost của ảnh này?',
      human: 'Đã thấy: {user}',
      auto: 'Tự đóng: {why}',
    },
    sync: 'Đồng bộ',
    syncing: 'Đang đồng bộ…',
    read: 'Đọc ngay',
    download: 'Excel',
    syncedAt: 'Đồng bộ lúc {time}',
    neverSynced: 'Chưa đồng bộ',
    history: 'Đang chép lịch sử kênh: {done} / khoảng {total} bài',
    syncFailed: 'Đồng bộ lỗi: {error}',
    reader: {
      waiting: '{n} ảnh đã chọn chờ Claude đọc',
      failed: '{n} ảnh không đọc được',
      running: 'Đang đọc trên máy của {user} từ {time}: đọc {read}, lỗi {failed}',
      lastRun: 'Lần chạy của {user}, {time}: đọc {read}, lỗi {failed}',
      nothing: 'Không còn ảnh chờ',
    },
    help: {
      title: 'Cách Claude đọc ảnh',
      step1: 'Một lần cho mỗi máy: cài Claude Code và đăng nhập, rồi bấm "Cài trình đọc" và chạy tệp vừa tải về.',
      step2: 'Đánh dấu "Chọn" các ảnh cần Claude đọc (ô ở tiêu đề chọn cả trang). Ảnh đã map hoặc đã đọc thì không chọn được.',
      step3: 'Bấm "Đọc ngay" và cho phép trình duyệt mở trình đọc.',
      step4: 'Một cửa sổ trên máy này hiện Claude đọc từng ảnh đã chọn; cứ để mở, đọc xong cửa sổ tự đóng.',
      step5: 'Các dòng tự cập nhật khi từng ảnh được đọc xong. Ảnh "Claude không đọc được" có thể chọn lại.',
      note: 'Nhiều máy có thể đọc cùng lúc: mỗi máy lấy ảnh khác nhau. "Gỡ trình đọc" gỡ khỏi một máy.',
    },
    install: {
      button: 'Cài trình đọc',
      hint: 'Một lần cho mỗi máy: để "Đọc ngay" mở Claude Code trên máy này. Máy cần cài Claude Code và đã đăng nhập.',
      opened: 'Claude Code sẽ mở trong một cửa sổ trên máy này (cho phép trình duyệt mở). Nếu không có gì mở ra, máy này cần cài trình đọc một lần:',
      remove: 'Gỡ trình đọc',
      removeHint: 'Gỡ trình đọc khỏi máy này: "Đọc ngay" sẽ không mở Claude Code trên máy này nữa.',
    },
    rows: '{from}–{to} / {shown} bài',
    pager: { label: 'Trang', first: 'Trang đầu', prev: 'Trang trước', next: 'Trang sau', last: 'Trang cuối', size: 'Mỗi trang' },
    narrow: 'Chỉ hiện {max} bài mới nhất: thu hẹp ngày hoặc tìm kiếm.',
    empty: 'Không có bài nào theo bộ lọc này.',
    col: {
      posted: 'Ngày đăng',
      author: 'Người đăng',
      phoneMm: 'SĐT (MST)',
      message: 'Nội dung',
      links: 'Liên kết',
      mapped: 'Đã map',
      chosen: 'Chọn',
      chosenFor: 'cho LLM',
      llm: 'Claude',
      method: 'Hình thức',
      amount: 'Số tiền',
      sender: 'Người gửi',
      receiver: 'Người nhận',
      txnAt: 'Thời gian CK',
      success: 'Thành công',
      phonePic: 'SĐT trong ảnh',
      description: 'Nội dung CK',
    },
    picture: 'Ảnh',
    customerLink: 'Mở Order Hist của khách này',
    post: 'Bài',
    reply: 'trả lời',
    llm: {
      read: 'Đã đọc',
      waiting: 'Đã chọn',
      failed: 'Lỗi',
      none: '—',
    },
    panel: {
      title: 'Ảnh',
      prev: 'Ảnh trước (←)',
      next: 'Ảnh sau (→)',
      close: 'Đóng (Esc)',
      move: 'Kéo để di chuyển khung, kéo một góc để đổi cỡ; bấm đúp để đưa về như cũ',
      resize: 'Kéo để đổi cỡ',
      reset: 'Đưa khung về bên phải, cỡ như cũ',
      full: 'Ảnh gốc',
      post: 'Mở trong Mattermost',
      failed: 'Không tải được ảnh từ Mattermost',
    },
    yes: 'Có',
    no: 'Không',
  },
}
